import api from 'api'
import { CACHE_TAG_BILLING_INVOICE_GROUP_LIST, CACHE_TAG_BILLING_INVOICE_GROUP_DETAILS } from '../../cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    updateInvoiceGroup: build.mutation({
      query: ({ invoiceGroupId, body }) => ({ url: `/api/v1/billing/invoice/groups/${invoiceGroupId}`, method: 'PUT', body }),
      invalidatesTags: (result, error, arg) => [
        CACHE_TAG_BILLING_INVOICE_GROUP_LIST,
        { type: CACHE_TAG_BILLING_INVOICE_GROUP_DETAILS, id: arg.invoiceGroupId },
      ],
    }),
  }),
})

export const { useUpdateInvoiceGroupMutation } = extendedApi
